module.exports = __webpack_public_path__ + "static/media/14-9.6988c631.mp3";